export default "__VITE_ASSET__116eb5cd__$_?react__"